var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timestamp !== null)?_c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.formatTimeUserZone(_vm.timestamp, true))+" ")]),_c('div',[_vm._v(" "+_vm._s(_vm.formatTime(_vm.timestamp, _vm.getComputedTimeZone(), true))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }